import styled from "styled-components"

export const RattingBoxWrapper = styled.div`
.rating_box{ 
    &_title{
        font-size: 1.0rem;
        color: #ff6801;
        display: flex;
        align-items: center;
    }
    &_list{
        margin: 0;
        padding: 0;
        list-style: none;
        width: 70%;
        .progress_bar {
            width: 100%;
            height: 6px;
            background-color: #ececec;
            margin-right: 12px;
            position: relative;
            span{
                position: absolute;
                display: block;
                background-color: #ff6801;
                bottom: 0;
                left: 0;
                top: 0;
            }
        } 
        &_item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            &_left{
                width: 90%;
                display: flex;
                align-items: center;
                div{
                    p{
                        margin: 0 6px 0 0;
                        font-size: 0.8rem;
                    }
                    i{
                        font-size: 0.6rem;
                        margin: 0 6px 0 0;
                    }
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            &_percent{
                color: rgb(106, 39, 174);
                font-size: 0.8rem;
            }
        }
    }
    .star_icon{
        fill: #ff6801;
    }
}
`